import { Button } from '../../atoms/Button';
import { Icon } from '../../atoms/Icon';
import { Breadcrumbs, BreadcrumbsItem } from '../Breadcrumbs';

interface IMinimalHeader {
  breadcrumb: BreadcrumbsItem[];
  actionText: string;
  action: () => void;
}

//Minimal header é o breadcrumb acompanhado de um botão de ação
export function MinimalHeader({
  breadcrumb,
  actionText,
  action,
}: IMinimalHeader) {
  return (
    <div className='flex justify-between xs:flex-col xs:items-start md:flex-row md:items-center'>
      <div className='flex-1'>
        <Breadcrumbs items={breadcrumb} />
      </div>
      <div className='flex flex-1 justify-end xs:mt-2 md:mt-0'>
        <Button
          allowReadOnly
          variant='text'
          size='small'
          className='p-0'
          onClick={() => action()}
        >
          <Icon Icon='info' type='material' className='xs:text-sm md:text-md' />
          {actionText}
        </Button>
      </div>
    </div>
  );
}
